import { createContext } from 'react';
export var loadingContextDefaultValue = {
    imxLoading: false,
    setImxLoading: function (_value) { return undefined; },
    serverLoading: false,
    setServerLoading: function (_value) { return undefined; },
};
export var LoadingContext = createContext(loadingContextDefaultValue);
